import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast } from '@/services/toast-service';
import { deleteBroadcastMessage } from '@/services/coloc-api/admin';
import { usePopUpConfirmation } from '@/features/shared/pop-up-confirmation/hooks';

export const useDeleteBroadcastMessage = () => {
  const queryClient = useQueryClient();
  const { openPopUpConfirmation } = usePopUpConfirmation();

  const mutation = useMutation({
    mutationKey: ['deleteBroadcastMessage'],
    mutationFn: (id: number) => deleteBroadcastMessage(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['broadcast-messages'] });
      openPopUpConfirmation({
        type: 'feedback',
        title: 'Broadcast message deleted',
        description: 'The broadcast message has been deleted successfully.',
        confirmLabel: 'Done',
      });
    },
    onError: () => {
      showToast.error({
        title: 'Failed to delete broadcast message',
        text: 'Please try again.',
      });
    },
  });

  return {
    deleteMessage: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
